import { UsdValue } from '@sonarwatch/portfolio-core';
import { amountFormat } from './amountFormat';
import { Currency } from '@/types';
import { defaultCurrency } from '@/constants';
import displayCurrency from './currency/displayCurrency';

export function priceFormat(
  price: UsdValue | undefined,
  ratio = 1,
  currency: Currency = defaultCurrency,
  rate = 1,
) {
  if (!price) return undefined;
  const formattedPrice = price * rate * ratio;
  return displayCurrency(
    amountFormat(formattedPrice),
    currency.symbol,
    currency.symbolPosition,
  );
}
